import { BaseTheme } from "@swiggy-private/dls-web-common/dist/components/themes/precomputed/Base/BaseTheme";

const PREFIX = "m2c-halfcard";

export const M2C_HALFCARD_TEST_IDS = {
    HALFCARD: `${PREFIX}-halfcard`,
    TITLE: `${PREFIX}-title`,
    ASSET: `${PREFIX}-asset`,
    CONTENT: `${PREFIX}-content-container`,
    CONTENT_V2: `${PREFIX}-content-container-v2`,
    CONTENT_ITEM: `${PREFIX}-content-item`,
    TITLE_V2: `${PREFIX}-title-v2`,
    SUBTITLE: `${PREFIX}-subtitle`,
    SUBTITLE_V2: `${PREFIX}-subtitle-v2`,
    PRIMARY_CTA: `${PREFIX}-primary-cta`,
    SECONDARY_CTA: `${PREFIX}-secondary-cta`,
    CLOSE_BUTTON: `${PREFIX}-close-button`,
    LOGO: `${PREFIX}-logo`,
    LOGO_V2: `${PREFIX}-logo-v2`,
    NOTE: `${PREFIX}-note`,
    DE: `${PREFIX}-delivery-executive`,
    GRATIFICATION_HEADER: `${PREFIX}-gratification-header`,
    GRATIFICATION_TITLE: `${PREFIX}-gratification-title`,
    GRATIFICATION_CONTENT: `${PREFIX}-gratification-content-container`,
    GRATIFICATION_CONTENT_ITEM: `${PREFIX}-gratification-content-item`,
};

export const M2C_BLACK_RENEWAL_COIN_LOTTIE = "M2C_BLACK_RENEWAL_COIN_LOTTIE";
export const M2C_BLACK_TITLE_TEXT_COLOR = "linear-gradient(90deg, #836662 -12.93%, #DDD1C9 96.4%)";

export const PLACEHOLDERS = {
    INLINE_IMG_START: "{{img|",
    INLINE_IMG_END: "}}",
};

export const ASSET_PATH = "portal/m/m2c_card_comms";
export const BLACK_ASSET_PATH = "BLCK";

export const FULL_RAY_BACKGROUND = `${ASSET_PATH}/full_ray.png`;
export const HALF_RAY_BACKGROUND = `${ASSET_PATH}/half_ray.png`;
export const DELIVERY_EXECUTIVE = `${ASSET_PATH}/swiggy_DE.png`;
export const DELIVERY_EXECUTIVE_SHADOW = `${ASSET_PATH}/DE_shadow_v2.png`;
export const COINES_AND_STARS = `${ASSET_PATH}/coins_and_stars.png`;
export const XP2_MASTHEAD = `${ASSET_PATH}/XP-masthead-without-logo.png`;
export const STRIP_HEADER = `portal/m/bulls-eye-cart-upsell/header_background.png`;
export const ZIGZAG_PATTERN = `${ASSET_PATH}/zigzag_pattern_v2.png`;
export const SPARKLING_STARS = `${ASSET_PATH}/stars.png`;
export const CLUSTER_STARS = `${BLACK_ASSET_PATH}/Stars%20cluster.png`;
export const LINES_BACKGROUND = `${BLACK_ASSET_PATH}/M2C%20bg.png`;
export const STAR_IMAGE = `${BLACK_ASSET_PATH}/Star%20icon-%20Pop%20up%20Cart.png`;
export const LINES_BACKGROUND_POPUP = `${BLACK_ASSET_PATH}/Cart/Pop-up%20bg%20lines.png`;

export const DISABLE_GREY_FROM_IMG = { light: "", dark: "" };

export const backgroundImageFormate = (url: string) => `url(${url})`;

export const GRATIFICATION_FALLBACK_HEIGHT = 388;

export const COLOR_TAGS = {
    OPEN: `<span style="color:${BaseTheme.colors[BaseTheme.colorMode].primary};">`,
    CLOSE: `</span>`,
};

export const STRIKED_TAGS = {
    TO_FIND: `<s>`,
    TO_BE_REPLACED: `<s style="color:${BaseTheme.colors[BaseTheme.colorMode].text_Low_Emphasis};">`,
};

export const DEFAULT_PROGRESS_DURATION = 3;
export const DELAY_FOR_PROGRESS_BAR = 3;
export const DELAY_FOR_DIVIDER_POPUP = 0.5;
export const DELAY_FOR_DIVIDER_HALFCARD = 2.5;
export const THOUSAND = 1000;
/**
 * The delay (in milliseconds) for state change from preState to postState to make transition smoother.
 */
export const STATE_CHANGE_DELAY = 800;

export const CLOSED_CTA_TEXT = "Cross icon";
export const CLOSED_CTA_TEXT_GRATIFICATION = "click-animated-half-card-close-icon";
export const POST_STATE_CLOSE_CTA_TEXT = "Auto closed after post state duration";

export const EMPTY_FUNCTION = (): void => void 0;

export const DELIVERY_EXECUTIVE_PROPS = {
    width: "134px",
    height: "128px",
    customBackground: { ...DISABLE_GREY_FROM_IMG },
};

export const SWIGGY_LOGO_PROPS = {
    alt: "Swiggy Logo",
    width: "162px",
    height: "28px",
    customBackground: { ...DISABLE_GREY_FROM_IMG },
};

export const XP2_MASTHEAD_PROPS = (isOneLite?: boolean) => ({
    height: isOneLite ? "34" : "32",
    width: isOneLite ? "176" : "90",
    alt: "XP2 Masthead logo",
    customBackground: { ...DISABLE_GREY_FROM_IMG },
});

export const GRATIFICATION_POPUP_LOGO = {
    width: "138px",
    height: "24px",
    alt: "Swiggy one black",
};
